<div [ngClass]="{'!mt-0': showBigSearchHomePage()}"
     class="flex flex-col items-baseline md:items-center lg:-mt-[25px] mb-0 ml-[-.5rem] md:ml-[0rem]">
  <section class="flex items-center sm:ml-[25px] md:ml-0">
    <button #menu (click)="openMenuDropdown(menu)" [ngClass]="{'!text-white': showBigSearchHomePage()}"
            aria-controls="menu"
            aria-expanded="false"
            class="inline-flex items-baseline md:w-10 h-10 justify-center text-sm text-gray-500 rounded-lg
            hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-white
            dark:hover:bg-gray-700 dark:focus:ring-gray-600" type="button">
      <span class="sr-only">Open main menu</span>
      <svg aria-hidden="true" class="w-6 h-6" fill="none" viewBox="0 0 17 14" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1h15M1 7h15M1 13h15" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
              stroke-width="2"/>
      </svg>
    </button>

    <a (click)="goBackToHomePageEvent.emit()" class="flex w-[170px] h-[54px] mt-[2px] relative items-center logo-container
                !mb-[2px] !sm:mb-1 cursor-pointer">
      @if (appTheme() === 'dark' || showBigSearchHomePage()) {
        <img [attr.alt]="'Songhunt Dark Logo'" [fill]="true" class="mr-3" ngSrc="/assets/nav_bar/logo_dark.png"
             priority>
      } @else {
        <img [attr.alt]="'Songhunt Light Logo'" [fill]="true" class="mr-3" ngSrc="/assets/nav_bar/logo_light.png"
             priority>
      }
    </a>
  </section>
</div>
